/**
 * ViewButton
 *
 * Shared icon-only "View" affordance for every admin table row.
 * Same outlined-pill shape as RefreshButton so every interactive control
 * across the admin panel feels familiar. The button is intentionally compact
 * (just the eye icon) — the whole row is also clickable, so this icon is
 * really a redundant visual cue for users who scan the actions column.
 *
 * Usage:
 *   <ViewButton onClick={(e) => { e.stopPropagation(); openModal(row); }} />
 *   <ViewButton onClick={...} title="View order" />
 *
 * Note: when used inside a clickable <tr>, call `e.stopPropagation()` in the
 * onClick handler so the row's own click handler doesn't fire twice.
 */

import React from 'react';
import { FiEye } from 'react-icons/fi';
import Button from './Button';

export default function ViewButton({
  onClick,
  title = 'View details',
  disabled = false,
  className = '',
}) {
  return (
    <Button
      size="sm"
      iconOnly
      className={`cs-btn--header-action ${className}`}
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      <FiEye className="text-[13px]" />
    </Button>
  );
}
